export const SET_WEEKDAY = 'setWeekDay'
export const SET_WEEKDAYS = 'setWeekDays'
export const WEEKDAY_RESET_STATE = 'weekDayResetState'